import axios from "axios";
import moment from "moment";
import "moment/locale/ko";

import { Cookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import { loadAlert } from "redux/reducers/top";
import { useHistory } from "react-router-dom";
import { setAppData, goAppUrl } from "assets/js/apphandle";
import { useDispatch, useSelector } from "react-redux";
import { loginRequestAction, logoutAction } from "redux/reducers/user";
import { loadMainAction } from "redux/reducers/home";

const cookies = new Cookies();
const crypto = require("crypto");

let cookieExpires = new Date();
cookieExpires.setDate(cookieExpires.getDate() + 180);

export const changeSubmitDate = ({ year, month, day }) => {
  if (!year || !month || !day) return "";

  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;

  return `${year}${month}${day}`;
};

export const changeDatepickerDate = (date) => {
  // YYYY-MM-DD
  let mnt = moment(date).format("YYYY-MM-DD");
  let d = mnt.split("-");
  return {
    year: Number(d[0]),
    month: Number(d[1]),
    day: Number(d[2]),
  };
};

export const changeSubmitTime = (time) => {
  return time.replace(":", "");
};

export const changeTimePickerTime = (timeNumber) => {
  return `${timeNumber.slice(0, 2)}:${timeNumber.slice(2, 4)}`;
};

export const displayYmdHis = (y, h) => {
  return y && h ? moment(`${y} ${h}`).format("YYYY-MM-DD HH:mm:ss") : "-";
};

export const zeroFill = (number) => {
  if (number < 10) {
    return `0${number}`;
  } else {
    return `${number}`;
  }
};

export const showOrdinal = (index) => {
  return index % 10 === 1
    ? index + "st"
    : index % 10 === 2
      ? index + "nd"
      : index % 10 === 3
        ? index + "rd"
        : index + "th";
};

export const handleDownloadFile = (afSeq, filePath) => {
  console.log("item", afSeq);
  axios
    .get("/api/st/attach-file/download/" + afSeq, {
      responseType: "blob",
    })
    .then((res) => {
      console.log(res);
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filePath);
      document.body.appendChild(link);
      link.click();
    });
};

export const rem = (size) => {
  let defaultSize = 16;
  const rem = size / defaultSize;
  return rem + "rem";
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
};

export const onlyNumber = (num) => {
  return num && num.replace(/[^0-9]/g, "");
};

export const onlyEmailAddr = (num) => {
  return num && num.replace(/[^-_\.0-9A-za-z]/g, "");
};

export const displayTel = (tel) => {
  const regex = /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)?([0-9]{4})/;
  tel = tel ? tel.replace(regex, "$1-$2-$3") : "";
  return tel;
};

export const displayBirth = (birth) => {
  let result = birth ? birth.substr(2) : "";
  return result;
};

export const logout = (returnFunc) => {
  if (window.Android) {
    window.Android.logout(returnFunc);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ios
  ) {
    // Call iOS interface
    var message = {
      command: "logout",
      func: returnFunc,
    };
    window.webkit.messageHandlers.ios.postMessage(message);
  } else {
    console.log("error: ", error);
    cookies.remove("favInfo", { path: "/" });
    cookies.remove("X-AUTH-TOKEN", { path: "/" });
    cookies.remove("X-REFRESH-TOKEN", { path: "/" });
    cookies.remove("autoToken", { path: "/" });
    window.location.href = "/";
  }
};

function refreshTokenAPI1() {
  return new Promise((resolve) => {
    axios
      .post(`/api/auth/token`, {
        grantType: "refresh_token",
        refreshToken: cookies.get("X-REFRESH-TOKEN"),
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        window.logoutReturnFunc4 = () => {
          cookies.remove("favInfo", { path: "/" });
          cookies.remove("X-AUTH-TOKEN", { path: "/" });
          cookies.remove("X-REFRESH-TOKEN", { path: "/" });
          cookies.remove("autoToken", { path: "/" });
          setAppData();
          window.location.href = "/";
        };
        logout("logoutReturnFunc4");
      });
  });
}

export const refreshToken = async () => {
  const newToken = await refreshTokenAPI1();
  setCookiesSync(
    "X-AUTH-TOKEN",
    `${newToken.data.tokenType} ${newToken.data.accessToken}`
  );
  // cookies.set(
  //   "X-AUTH-TOKEN",
  //   `${newToken.data.tokenType} ${newToken.data.accessToken}`,
  //   {
  //     path: "/",
  //     expires: cookieExpires,
  //   }
  // );
  setCookiesSync("X-REFRESH-TOKEN", newToken.data.refreshToken);
  // cookies.set("X-REFRESH-TOKEN", `${newToken.data.refreshToken}`, {
  //   path: "/",
  //   expires: cookieExpires,
  // });
  setCookiesSync("autoToken", newToken.data.autoToken);
  // if (newToken.data.autoToken) {
  //   cookies.set("autoToken", `${newToken.data.autoToken}`, {
  //     path: "/",
  //     expires: cookieExpires,
  //   });
  // }
  axios.defaults.headers.Authorization = `${newToken.data.tokenType} ${newToken.data.accessToken}`;
  const myDecodedToken = jwt_decode(newToken.data.accessToken);
  console.log("myDecodedToken", myDecodedToken);
  return myDecodedToken;
};

export const getCryptoPwd = (pwd) => {
  if (!pwd) return "";

  let result = "";
  for (let i = 0; i < pwd.length; i++) {
    let code = pwd.charCodeAt(i) + 20;
    result += String.fromCharCode(code);
  }

  const hashedPw = crypto.createHash("sha512").update(result).digest("base64");
  return hashedPw;
};

export const dateDayFormat = (date) => {
  return date ? moment(date).format("YY.MM.DD(dd)") : "";
};

export const eventDateFormat = (start, end) => {
  return start ? `${dateDayFormat(start)} ~ ${dateDayFormat(end)}` : "";
};

export const evtDateFormat = (start, end) => {
  return start && end != "99991231"
    ? `${dateDayFormat(start)} ~ ${dateDayFormat(end)}`
    : "";
};

export const isWeb =
  window.Android ||
    (window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios)
    ? false
    : true;

export const isJsonString = (str) => {
  try {
    var json = JSON.parse(str);
    return typeof json === "object";
  } catch (e) {
    return false;
  }
};

export const renderNoti = (item) => {
  if (item) return item.split("\n");
  return [];
};

export const replaceBrTag = (str) => {
  str = str ? str.replace(/ /g, "&nbsp;") : "";
  str = str ? str.replace(/(?:\r\n|\r|\n)/g, "<br />") : "";
  return str;
};
// app call
export const goCert = (func) => {
  if (isWeb) {
    window.open(
      `${axios.defaults.baseURL}/api/web/niceid/cert.do?func=${func}`,
      "",
      "width = 500, height = 800"
    );
  } else {
    const url = `${axios.defaults.baseURL}/api/app/niceid/cert.do?func=${func}`;
    goAppUrl(url, 1);
  }
};

export const goShare = (scheme, seq) => {
  let url = `${location.origin}/${scheme}.html?seq=${seq}`;
  if (isWeb) {
    let textarea = document.createElement("textarea");
    document.body.appendChild(textarea);
    textarea.value = url;
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    alert("URL이 복사되었습니다. " + JSON.stringify(url));
  } else {
    location.href = `csrmegamart://share?${url}`;
  }
};

export const goPush = () => {
  if (!isWeb) {
    location.href = `csrmegamart://push-info`;
  }
};

export const maxLen = (value, len) => {
  return value.slice(0, len);
};

export const numberFormat = (value) => {
  return value ? value.toLocaleString() : "";
};

export const goLink = (url) => {
  console.log("url", url);
  if (isWeb) {
    window.open(url);
  } else {
    window.location.href = `csrmegamart://external-url?${url}`;
  }
};

export const noSplit = (value) => {
  let result = "";
  let str = String(value);

  if (value) {
    for (let i = 0; i < value.length; i++) {
      // if (i == 0)
      result += str.substr(i * 4, 4) + " ";
      // else result += str.substr(4 + (i - 1) * 3, 3) + " ";
    }
    //13자리 회원번호를 4 3 3 3으로 끊어 출력
  }

  return result;
};

export const getCardName = (cd) => {
  switch (cd) {
    case "ABA01":
      return "신한카드";
    case "ABA02":
      return "국민카드";
    case "ABA03":
      return "현대카드";
    case "ABA04":
      return "삼성카드";
    case "ABA05":
      return "롯데카드";
    case "ABA06":
      return "농협카드";
    case "ABA07":
      return "비씨카드";
    case "ABA08":
      return "하나카드";
    default:
      return "****";
  }
};

export const cardImg = (cd) => {
  switch (cd) {
    case "ABA01":
      return "shinhan";
    case "ABA02":
      return "kb";
    case "ABA03":
      return "hyundai";
    case "ABA04":
      return "samsung";
    case "ABA05":
      return "lotte";
    case "ABA06":
      return "nh";
    case "ABA07":
      return "bc";
    case "ABA08":
      return "hana";
    default:
      return "";
  }
};

export const goLogin = (data) => {
  let form = {
    grantType: "cert",
    ci: data.ci,
  };
  axios.post("/api/auth/token", form).then((res) => {
    window.loginComplete3 = function (authKey, pushUrl) {
      window.location.href = "/";
    };

    if (window.Android) {
      window.Android.login(data.no, "loginComplete3");
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      // Call iOS interface
      var message = {
        command: "login",
        id: data.no,
        func: "loginComplete3",
      };
      window.webkit.messageHandlers.ios.postMessage(message);
    }
    window.location.href = "/";
  });
};

export const goMegaMall = (key = "", value = "") => {
  var scheme = `megamartmall://wakeup`;
  var params = key ? `?${key}` + (value ? `=${value}` : "") : "";
  var andUrl = `intent://megamartmall#Intent;scheme=${scheme}${params};action=android.intent.action.VIEW;category=android.Intent.category.BROWSABLE;package=com.megamart.app.mall;end`;
  var iosUrl = `${scheme}${params}`;
  var andMarketUrl =
    "https://play.google.com/store/apps?id=com.megamart.app.mall";
  var iosMarketUrl =
    "https://apps.apple.com/kr/app/%EB%A9%94%EA%B0%80%EB%A7%88%ED%8A%B8/id430549569";

  var userAgent = navigator.userAgent;
  var visitedAt = new Date().getTime(); // 방문 시간
  if (userAgent.match(/iPhone|iPad|iPod/)) {
    window.location.href = iosUrl;

    setTimeout(function () {
      if (new Date().getTime() - visitedAt < 2000) {
        window.location.href = iosMarketUrl;
      }
    }, 1000);
  } else if (userAgent.match(/Android/)) {
    window.location.href = andUrl;

    setTimeout(function () {
      window.location.href = andMarketUrl;
    }, 2000);
  }
};

export const setInitCookies = (key, value) => {
  // 최초 로그인 시 날짜 넣기

  var cookieExpires = new Date();
  cookieExpires.setDate(cookieExpires.getDate() + 180);

  // if(key == 'favInfo') {
  //   value = JSON.stringify(value);
  // }

  cookies.set(key, value, {
    path: "/",
    expires: cookieExpires,
  });
  // 웹 쿠키 > 앱 저장
  setAppData();
};

export const setCookiesSync = (key, value) => {
  // 로그인 시 expires가져와서 넣기
  let cookieExpires = new Date(cookies.get("expires"));

  // if(key == 'favInfo') {
  //   value = JSON.stringify(value);
  //   alert('value :' + value)
  // }

  cookies.set(key, value, {
    path: "/",
    expires: cookieExpires,
  });
  // 웹 쿠키 > 앱 저장
  setAppData();
};

// export const autoLogin = async () => {
//   let checked = cookies.get("checked") || "";
//   let autoToken = cookies.get("autoToken") || "";
//   if (checked == "true" && autoToken) {
//     let form = {
//       grantType: "auto",
//       username: autoToken,
//     };
//     dispatch(loginRequestAction(form));
//   } else {
//     window.logoutReturnFunc = () => {
//       cookies.remove("favInfo", { path: "/" });
//       cookies.remove("X-AUTH-TOKEN", { path: "/" });
//       cookies.remove("X-REFRESH-TOKEN", { path: "/" });
//       cookies.remove("autoToken", { path: "/" });
//       dispatch(logoutAction());

//       dispatch(
//         loadMainAction({
//           schTp: "1",
//           schStore: "2701",
//         })
//       );
//     };
//     logout("logoutReturnFunc");
//     cookies.remove("favInfo", { path: "/" });
//     cookies.remove("X-AUTH-TOKEN", { path: "/" });
//     cookies.remove("X-REFRESH-TOKEN", { path: "/" });
//     cookies.remove("autoToken", { path: "/" });
//     dispatch(logoutAction());

//     dispatch(
//       loadMainAction({
//         schTp: "1",
//         schStore: "2701",
//       })
//     );
//   }
// };
